const FieldError = ({ name, touched, errors }) => {
    // console.log({ name, touched, errors }, touched?.[name], errors?.[name], 'kkkkkkkkkkkkkkkk')
    if (!touched?.[name] || !errors?.[name]) return null;
    return <span className="text-danger d-block mt-1">{errors[name]}</span>;
};

export default FieldError;